var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbUpSolid = function SvgThumbUpSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.89 9.544h.002l2.713-4.34a2.03 2.03 0 0 1 1.72-.954 2.03 2.03 0 0 1 2.027 2.027v2.606h4.33a2.06 2.06 0 0 1 1.57.724 2.07 2.07 0 0 1 .475 1.663l-.916 5.955a2.075 2.075 0 0 1-2.05 1.76H9.176c-.473 0-.94-.112-1.365-.323l-.677-.339H6.89l.001-.03v-8.75zm-1.108 0v8.748l.001.031H4.577a1.326 1.326 0 0 1-1.327-1.327v-6.125a1.326 1.326 0 0 1 1.327-1.327z"
  })));
};
export default SvgThumbUpSolid;